import { useState } from "react";
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input"
import { useLocation } from "wouter";
import useMusioApi from "@/contexts/client/musio-client-context";
import { LoadingIndicator } from "@/components/ui/loading-indicator";
import { ReactComponent as Logo } from "@/assets/musio-logos/logo_center_top.svg";
import { NotificationRow } from "@/components/ui/notification-row";

const CONFIRMATION = "If your email exists, you will recieve a recovery email from Musio";

export default function ForgotPassword() {
  const [_, navigate] = useLocation();
  const { musioApi } = useMusioApi();

  const [email, setEmail] = useState("");
  const [confirmation, setConfirmation] = useState<string>();

  const { mutate, isPending, isError } = musioApi.useMutation("post", "/recover", {
    onSuccess: () => setConfirmation(CONFIRMATION),
    retry: 0,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setConfirmation(undefined);
    mutate({ body: { authId: email } });
  };

  return (
    <div className="flex flex-col items-center justify-center font-inter space-y-2">
      <div className="w-[128px] h-[128px] flex-shrink-0 flex justify-center items-center">
        <Logo />
      </div>
      <form onSubmit={handleSubmit} className="max-w-[478px] w-full">
        <Card className="flex items-center justify-center flex-col musio-glass h-full">
          <CardHeader className="flex items-center justify-center card-header-padded">
            <div className="flex items-center justify-between text-musio-lilac">
              <CardTitle className="text-[30px]">Forgot Password</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="w-full space-y-2 card-content-padded flex flex-col justify-center items-center">
            {isError && (
              <NotificationRow className="w-full" intent="error">
                {"Something went wrong. Please check your email input"}
              </NotificationRow>
            )}
            <Input
              type="email"
              id="email"
              placeholder="Email."
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="bg-musio-bg-light border-musio-bg-dark"
            />
            {confirmation ?
              <NotificationRow intent="info">
                {confirmation}
              </NotificationRow> : null
            }
          </CardContent>
          <CardFooter className="p-5 w-full flex flex-col justify-center items-center gap-2">
            {isPending ? (
              <LoadingIndicator />
            ) : (
              <>
                <Button
                  type="submit"
                  className="w-full font-bold bg-musio-green text-musio-mid-gray"
                  disabled={isPending || !!confirmation || !email}
                >
                  Submit
                </Button>
                <Button
                  type="button"
                  className="w-full border-primary bg-musio-mid-gray font-bold text-musio-lilac border-none"
                  variant="outline"
                  onClick={e => {
                    e.preventDefault();
                    navigate("~/login");
                  }}
                >
                  Back to Login
                </Button>
              </>
            )}
          </CardFooter>
        </Card>
      </form>
    </div >
  );
}
